import { theme } from '@Guidelines/Theme/theme';
import SectionCard from '@Guidelines/Component/SectionCard';
import type WorkflowStepView from '@UI/Store/OrganizationWorkflows/Views/WorkflowStepView';
import { css } from '@emotion/react';
import { Lock } from 'lucide-react';
import type * as React from 'react';

const stepStyle = css`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	padding: 0.875rem 1rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
`;

const rankStyle = css`
	display: flex;
	flex: none;
	align-items: center;
	justify-content: center;
	width: 1.875rem;
	height: 1.875rem;
	border-radius: 50%;
	background-color: ${theme.colors.track};
	color: ${theme.colors.inkSecondary};
	font-family: ${theme.fonts.body};
	font-size: 0.8125rem;
	font-weight: ${theme.fontWeights.semibold};
	line-height: 1;
`;

const labelStyle = css`
	flex: 1;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
	line-height: 1.4;
	color: ${theme.colors.ink};
`;

const lockStyle = css`
	display: flex;
	color: ${theme.colors.inkMuted};
`;

type Props = {
	readonly steps: readonly WorkflowStepView[];
};

/** The fixed steps of the transcription, listed for information only. */
const StepsSection: React.FC<Props> = ({ steps }) => {
	return (
		<SectionCard
			title="Étapes"
			description="Fixées par Dixit : elles sont affichées pour information et ne se modifient pas."
		>
			{steps.map((step, index) => (
				<div key={step.id} css={stepStyle}>
					<span css={rankStyle}>{index + 1}</span>
					<span css={labelStyle}>{step.label}</span>
					<span css={lockStyle}>
						<Lock size={15} aria-label="Non modifiable" />
					</span>
				</div>
			))}
		</SectionCard>
	);
};

export default StepsSection;
